import React from "react";
import { Row, Col } from "react-bootstrap";
import { InputField } from "../../../../Components/formElements/InputField";
import { RENT_SLAB_OPTIONS } from "./constants";
 // eslint-disable-next-line
import { calculateDays, calculateEndDate } from "./utils";

const MockTableDropdownMenu = ({ label, data, value, onChange, disabled }) => (
  <select
    className="form-select"
    value={value}
    onChange={(e) => {
      const selected = data.find((d) => d.name === e.target.value);
      onChange({
        value: e.target.value,
        codeValue: selected?.code,
        descValue: selected?.description,
      });
    }}
    disabled={disabled}
  >
    <option value="">{label}</option>
    {data.map((d, i) => (
      <option key={i} value={d.name}>
        {d.name}
      </option>
    ))}
  </select>
);

const GlobalRentConfigPanel = ({ config, onChange, disabled, itemCount }) => {
  const handleFieldChange = (field, value) => {
    let updates = { [field]: value };

    if (field === "fromDate") {
      // When From Date changes, recalculate To Date based on Days
      if (config.rentSlab === "Per Day") {
        // For Per Day: Keep existing days and recalculate To Date
        updates.toDate = calculateEndDate(value, config.days);
      } else {
        // For fixed slabs: Use slab's fixed days
        updates.toDate = calculateEndDate(value, config.days);
      }
    } else if (field === "days") {
      // When Days change, recalculate To Date
      const daysValue = parseInt(value) || 0;
      if (daysValue < 0) {
        // Prevent negative days
        updates.days = 0;
        updates.toDate = config.fromDate;
      } else {
        updates.toDate = calculateEndDate(config.fromDate, daysValue);
      }
    }

    onChange({ ...config, ...updates });
  };

  const handleSlabChange = (data) => {
    if (!data || !data.value) return;

    let updates = {
      rentSlab: data.value,
      rentSlabCode: data.codeValue,
      rentSlabDescription: data.descValue,
    };

    // Set fixed days based on slab
    switch (data.value) {
      case "7 Days":
        updates.days = 7;
        updates.toDate = calculateEndDate(config.fromDate, 7);
        break;
      case "15 Days":
        updates.days = 15;
        updates.toDate = calculateEndDate(config.fromDate, 15);
        break;
      case "30 Days":
        updates.days = 30;
        updates.toDate = calculateEndDate(config.fromDate, 30);
        break;
      case "Per Day":
        // Keep existing days or reset to 0
        updates.days = config.days || 0;
        updates.toDate = calculateEndDate(config.fromDate, updates.days);
        break;
      default:
        break;
    }

    onChange({ ...config, ...updates });
  };

  return (
    <div className="p-2 mb-2 border rounded bg-light">
      <Row>
        <Col
          xs={12}
          md={6}
          lg={3}
          className="commTopButtonRightLeftPadding mb-1"
        >
          <label className="form-label">
            Rent Slab <span className="text-danger">*</span>
          </label>
          <MockTableDropdownMenu
            index="global-rent-slab"
            label="Select Rent Slab"
            data={RENT_SLAB_OPTIONS}
            onChange={handleSlabChange}
            value={config.rentSlab}
            disabled={disabled}
          />
        </Col>

        <Col
          xs={12}
          md={6}
          lg={3}
          className="commTopButtonRightLeftPadding mb-1"
        >
          <InputField
            className="inputBox"
            type="date"
            label="From Date"
            name="fromDate"
            value={config.fromDate}
            onChange={(e) => handleFieldChange("fromDate", e.target.value)}
            disabled={disabled}
            required={true}
          />
        </Col>

        <Col
          xs={12}
          md={6}
          lg={3}
          className="commTopButtonRightLeftPadding mb-1"
        >
          <InputField
            className="inputBox"
            type="number"
            label="Days"
            name="days"
            value={config.days}
            onChange={(e) => handleFieldChange("days", e.target.value)}
            disabled={config.rentSlab !== "Per Day" || disabled}
            min="0"
            required={true}
          />
          {config.rentSlab !== "Per Day" && (
            <small className="text-muted d-block mt-1">Fixed by slab</small>
          )}
        </Col>

        <Col
          xs={12}
          md={6}
          lg={3}
          className="commTopButtonRightLeftPadding mb-1"
        >
          <InputField
            className="inputBox"
            type="date"
            label="To Date"
            name="toDate"
            value={config.toDate}
            disabled={true} // Always disabled - auto-calculated
          />
          <small className="text-muted d-block mt-1">
            Auto-calculated from From Date + Days
          </small>
        </Col>
      </Row>
    </div>
  );
};

export default GlobalRentConfigPanel;
